// components/NumpadModal.js
import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

const theme = {
  primary: '#1976d2',
  secondary: '#388e3c',
  accent: '#ffe082',
  danger: '#d32f2f',
  bg: '#f7fafd',
  card: '#fff',
};

const NumpadModal = ({
  visible,
  onClose,
  onNumberPress,
  activeTeamInput,
  inputValue
}) => {
  if (!visible) return null;

  const handleBackdropPress = () => {
    onClose();
  };

  return (
    <TouchableOpacity
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onPress={handleBackdropPress}
    >
      <View
        style={{
          backgroundColor: '#fff',
          borderRadius: 16,
          padding: 20,
          maxWidth: 400,
          width: '90%',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          elevation: 5,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.25,
          shadowRadius: 3.84,
        }}
      >
        {/* TITOLO sopra la griglia numerica */}
        <View
          style={{
            width: '100%',
            marginBottom: 20,
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: activeTeamInput === 'A' ? theme.danger : theme.secondary,
              textAlign: 'center',
            }}
          >
            {activeTeamInput === 'A' ? 'Punteggio A' : 'Punteggio B'}
          </Text>
          <Text
            style={{
              fontSize: 40,
              fontWeight: 'bold',
              color: activeTeamInput === 'A' ? theme.danger : theme.secondary,
              textAlign: 'center',
              margin: 0,
            }}
          >
            {inputValue || '0'}
          </Text>
        </View>

        {/* Tastierino numerico */}
        <View
          style={{
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* Riga 1-3 */}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              marginBottom: 10,
            }}
          >
            {[1, 2, 3].map((num) => (
              <TouchableOpacity
                key={num}
                onPress={() => onNumberPress(num.toString())}
                style={{
                  flex: 1,
                  padding: 15,
                  margin: 5,
                  backgroundColor: '#f8f8f8',
                  borderRadius: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 1,
                  borderColor: '#ddd',
                }}
              >
                <Text style={{ fontSize: 20, fontWeight: 'bold' }}>{num}</Text>
              </TouchableOpacity>
            ))}
          </View>

          {/* Riga 4-6 */}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              marginBottom: 10,
            }}
          >
            {[4, 5, 6].map((num) => (
              <TouchableOpacity
                key={num}
                onPress={() => onNumberPress(num.toString())}
                style={{
                  flex: 1,
                  padding: 15,
                  margin: 5,
                  backgroundColor: '#f8f8f8',
                  borderRadius: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 1,
                  borderColor: '#ddd',
                }}
              >
                <Text style={{ fontSize: 20, fontWeight: 'bold' }}>{num}</Text>
              </TouchableOpacity>
            ))}
          </View>

          {/* Riga 7-9 */}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              marginBottom: 10,
            }}
          >
            {[7, 8, 9].map((num) => (
              <TouchableOpacity
                key={num}
                onPress={() => onNumberPress(num.toString())}
                style={{
                  flex: 1,
                  padding: 15,
                  margin: 5,
                  backgroundColor: '#f8f8f8',
                  borderRadius: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 1,
                  borderColor: '#ddd',
                }}
              >
                <Text style={{ fontSize: 20, fontWeight: 'bold' }}>{num}</Text>
              </TouchableOpacity>
            ))}
          </View>

          {/* Riga 0, del, ok */}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
            }}
          >
            <TouchableOpacity
              onPress={() => onNumberPress('del')}
              style={{
                flex: 1,
                padding: 15,
                margin: 5,
                backgroundColor: theme.danger,
                borderRadius: 8,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>⌫</Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => onNumberPress('0')}
              style={{
                flex: 1,
                padding: 15,
                margin: 5,
                backgroundColor: '#f8f8f8',
                borderRadius: 8,
                justifyContent: 'center',
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#ddd',
              }}
            >
              <Text style={{ fontSize: 20, fontWeight: 'bold' }}>0</Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => onNumberPress('ok')}
              style={{
                flex: 1,
                padding: 15,
                margin: 5,
                backgroundColor: theme.secondary,
                borderRadius: 8,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>OK</Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Pulsante di chiusura */}
        <TouchableOpacity
          onPress={onClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 18,
            backgroundColor: 'transparent',
          }}
          accessibilityLabel="Chiudi tastierino"
        >
          <Text style={{ fontSize: 24, color: '#888' }}>×</Text>
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );
};

export default NumpadModal;
